import AfterLoginMock from "@/components/marketing/AfterLoginMock";
import MarketingSplitSection from "@/components/marketing/MarketingSplitSection";

export default function AfterLoginSection() {
  return (
    <MarketingSplitSection
      id="after-login"
      tone="white"
      title="The product after they log in"
      description="Journeys after they log in need a test account you provide. We sign in and use it like a customer."
    >
      <AfterLoginMock />
    </MarketingSplitSection>
  );
}
